import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "driver.js/dist/driver.css";
import "@/main.css";
import { App } from "@/App";

const container = document.getElementById("root");
if (!container) throw new Error("#root not found");

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
